import { ThemeInterface, themeNames } from "../theme";
import { colors } from "../../styles/variables";
import {
  fontNames,
  fontWeights,
  HexColor,
  textTransform,
} from "@pepdirect/shared/types";

type GatoradeColorNames = "gatoradeOrange" | "black";

export const GATORADE_COLORS: Record<GatoradeColorNames, HexColor> = {
  gatoradeOrange: "#fa5000",
  black: "#000",
};

export const GATORADE_SHARED_HEADING_STYLES = {
  fontWeight: fontWeights["700"],
  color: GATORADE_COLORS.black,
  lineHeight: "1.3",
};

export const GatoradeTheme: ThemeInterface = {
  name: themeNames.Gatorade,
  button: {
    primary: {
      color: GATORADE_COLORS.gatoradeOrange,
    },
    secondary: {
      color: colors.green,
    },
    tertiary: {
      color: GATORADE_COLORS.black,
      hollow: true,
      solidOnHover: true,
    },
    cancel: {
      color: colors.mediumGray,
      hollow: true,
      solidOnHover: true,
    },
    error: {
      color: colors.red,
    },
    text: {
      color: GATORADE_COLORS.gatoradeOrange,
    },
    disabled: {
      hollow: true,
    },
    fontFamily: fontNames["font-secondary"],
    textTransform: textTransform.uppercase,
    hasThinBorder: true,
  },
  color: {
    primary: GATORADE_COLORS.gatoradeOrange,
    secondary: GATORADE_COLORS.black,
    tertiary: colors.white,
    accent: GATORADE_COLORS.gatoradeOrange,
    disabled: colors.mediumGray,
    action: colors.green,
    error: colors.red,
    text: GATORADE_COLORS.black,
  },
  typography: {
    body: {
      lineHeight: "1.5",
      color: GATORADE_COLORS.black,
    },
    heading: {
      xxl: {
        fontSize: {
          desktop: "46px",
          mobile: "32px",
        },
        letterSpacing: "-1px",
        ...GATORADE_SHARED_HEADING_STYLES,
      },
      xl: {
        fontSize: {
          desktop: "32px",
          mobile: "24px",
        },
        letterSpacing: "-1px",
        ...GATORADE_SHARED_HEADING_STYLES,
      },
      l: {
        fontSize: {
          desktop: "24px",
          mobile: "20px",
        },
        letterSpacing: "-1px",
        ...GATORADE_SHARED_HEADING_STYLES,
      },
      m: {
        fontSize: {
          desktop: "18px",
          mobile: "18px",
        },
        ...GATORADE_SHARED_HEADING_STYLES,
      },
      s: {
        fontSize: {
          desktop: "16px",
          mobile: "16px",
        },
        ...GATORADE_SHARED_HEADING_STYLES,
      },
      xs: {
        fontSize: {
          desktop: "14px",
          mobile: "14px",
        },
        fontFamily: fontNames["font-secondary"],
        fontWeight: fontWeights["400"],
        color: GATORADE_COLORS.black,
        letterSpacing: "1px",
        textTransform: textTransform.uppercase,
      },
      xxs: {
        fontSize: {
          desktop: "14px",
          mobile: "14px",
        },
        fontWeight: fontWeights["400"],
        color: GATORADE_COLORS.black,
      },
    },
  },
  borderRadius: "0",
  header: {
    backgroundColor: GATORADE_COLORS.black,
    mobileLinkColor: colors.white,
    fontSize: "14px",
    navLinkOpacity: "1",
    fontFamily: fontNames["font-secondary"],
    textTransform: textTransform.uppercase,
  },
  footer: {
    backgroundColor: GATORADE_COLORS.black,
    textColor: colors.lightestGray,
    copyright: {
      textColor: colors.lightestGray,
      backgroundColor: GATORADE_COLORS.black,
    },
  },
};
